import { ReportView } from '@/features/reports/ReportView';
import type { components } from '@esnafai/shared/api';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';

const reportIds: readonly string[] = [
  'conversations_by_channel_day',
  'ai_vs_staff',
  'first_reply_time',
  'handoff_reasons',
  'most_asked_products',
  'top_question_types',
  'unanswered_questions',
] satisfies components['schemas']['ReportId'][];

export const Route = createFileRoute('/reports/$reportId')({
  validateSearch: z.object({
    preset: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
  }),
  // An id outside the fixed reports of Merchant API §3.11 is the not-found state.
  beforeLoad: ({ params }) => {
    if (!reportIds.includes(params.reportId)) throw notFound();
  },
  component: ReportView,
});
